export default __webpack_public_path__ + "static/media/errorregistro.fad0f01b.jpg";